<template>
    <div class="mainbody modulewrap">
        <div class="banner">
            <div class="bannerimg"><img :src="pageinfo.banner" /></div>
            <div class="bannertitle">
                <div class="main"><span>-{{pageinfo.title_en}}-</span></div>
                <div class="sub"><span>{{pageinfo.title}}</span></div>
            </div>
        </div>
        <div class="pagemain realwrap">
            <div class="pagecontact">
                <div class="map" v-if="pageinfo.note">
                    <baidu-map class="mapwrap" @ready="mapready"></baidu-map>
                </div>
                <div class="info">
                    <span v-html="$common.langinfo(pageinfo.content,pageinfo.content_en)"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'contact',
        data() {
            return {
                pageinfo: {},
            };
        },
        methods: {
            mapready({ BMap, map }) {

                let mapinfo = this.pageinfo.note.split('|');
                let maptitle = this.$common.langtitle(mapinfo[0]);
                let mapaddress = mapinfo[1];
                var myGeo = new BMap.Geocoder();
                // 将地址解析结果显示在地图上,并调整地图视野
                myGeo.getPoint(mapaddress, function (point) {
                    if (point) {
                        let top_left_control = new BMap.ScaleControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT });// 右下角，添加比例尺
                        let top_left_navigation = new BMap.NavigationControl({ anchor: BMAP_ANCHOR_TOP_RIGHT, offset: new BMap.Size(0, 50) });  //右上角，添加默认缩放平移控件
                        //var top_right_navigation = new BMap.NavigationControl({ anchor: BMAP_ANCHOR_TOP_RIGHT, type: BMAP_NAVIGATION_CONTROL_SMALL }); //右上角，仅包含平移和缩放按钮
                        map.addControl(top_left_control);
                        map.addControl(top_left_navigation);
                        //map.addControl(top_right_navigation);

                        map.centerAndZoom(point, 16);
                        var marker = new BMap.Marker(point);
                        map.addOverlay(marker);
                        let label = new BMap.Label(maptitle, { offset: new BMap.Size(20, 10) });
                        marker.setLabel(label);
                    } else {
                        //alert("您选择地址没有解析到结果!");
                    }
                });
            }
        },
        mounted() {

            this.$common.fetch({ 'act': 'tc_contact' }, res => {
                this.pageinfo = res.infodata;
            });
        }
    }
</script>
